import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { Tooltip as DxTooltip } from 'devextreme-react/tooltip';
import './customTooltip.css';

const CustomTooltip = ({
  tooltipClassname,
  textForTip,
  location = 'right',
  children,
  showEvent = 'mouseenter',
  hideEvent = 'mouseleave',
  ...props
}) => {
  const [targetElement, setTargetElement] = useState(null);

  const targetRef = useCallback((node) => {
    if (node !== null) {
      setTargetElement(node);
    }
  }, []);

  const getPosition = () => {
    switch (location) {
      case 'left':
        return 'left';
      case 'top':
        return 'top';
      case 'bottom':
        return 'bottom';
      case 'right':
      default:
        return 'right';
    }
  };

  return (
    <div style={{ display: 'inline-block' }}>
      <div ref={targetRef}>
        {children}
      </div>
      {targetElement && (
        <DxTooltip
          target={targetElement}
          position={getPosition()}
          showEvent={showEvent}
          hideEvent={hideEvent}
          className={tooltipClassname}
          {...props}
        >
          <div className="custom-tooltip-content">
            {textForTip}
          </div>
        </DxTooltip>
      )}
    </div>
  );
};

CustomTooltip.propTypes = {
  tooltipClassname: PropTypes.string,
  location: PropTypes.string,
  children: PropTypes.node,
  textForTip: PropTypes.string.isRequired,
  showEvent: PropTypes.string,
  hideEvent: PropTypes.string,
};

export default CustomTooltip;
